import styled from 'styled-components';

import { breakpoints, media } from '@/shared/components';

export const PageContainer = styled.div`
  --max-content-width: 1092px;

  max-width: calc(var(--max-content-width) + var(--page-padding-inline) * 2);
  padding-block: 24px;
  padding-inline: var(--page-padding-inline);
  margin-inline: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  &.wide {
    max-width: 1550px;
  }

  ${media.lg}, ${breakpoints.md}, ${breakpoints.sm} {
    overflow: auto;
    gap: 16px;
    padding: 16px;

    &.wide {
      padding: 24px;
    }
  }

  ${media.sm} {
    &.wide {
      padding: 16px;
    }
  }
`;
